@if (loading && !inline) {
    <div
        class="loadingOverlay"
        [ngClass]="internalOverlayStyleClass"
    ></div>
}

@if (loading && !smallIndicator) {
    <div
        class="loadingContainer"
        [ngClass]="{'loadingContainer--withMessage': loadingMessage}"
    >
        @if (loading && !smallIndicator) {
            <div
                class="loadingIndicator loadingIndicator--large"
                [ngClass]="internalStyleClass"
            >
                <svg viewBox="0 0 80 80">
                    <circle cx="40" cy="40" r="32"></circle>
                </svg>
                <div class="dot"></div>
            </div>
        }

        @if (loading && loadingMessage && !inline) {
            <div class="loadingIndicator-message">
                {{ loadingMessage | localize }}
            </div>
        }
    </div>
}

<div class="loadingIndicator loadingIndicator--small" *ngIf="loading && smallIndicator" [ngClass]="internalStyleClass">
    <svg viewBox="0 0 40 40">
        <circle cx="20" cy="20" r="16"></circle>
    </svg>
    <div class="dot"></div>
</div>
